module.exports = __webpack_public_path__ + "img/15-1.6cdf1510.svg";